import { showInformationNotification } from "../Notifications/notifications";

/**
 * Handles sharing of a page to social media platforms.
 * Most share links are simple links, but for copying link URLs
 * we need some custom logic.
 */
export const socialShare = () => {
  const shareComponents = document.querySelectorAll("[data-js-share-src]");

  for (const component of shareComponents) {
    const href = component.getAttribute("data-js-share-src");
    const copyBtn = component.querySelector("[data-js-share='copy']");

    copyBtn?.addEventListener("click", async () => {
      if (href?.length) {
        await navigator.clipboard.writeText(href);

        showInformationNotification("Link copied!");
      }
    });
  }
};
